import React, { type FC } from 'react';
import type { SSOConfig } from '~/common/api-client';
import type { OrNull } from '~/typings/utils';

interface UserLinkProps {
  id: string;
  ssoConfig?: OrNull<SSOConfig>;
}

const UserIdLink: FC<UserLinkProps> = ({ id, ssoConfig }) => {
  if (!ssoConfig) {
    return <>{id}</>;
  }

  return (
    <a
      href={`${ssoConfig.url}/auth/admin/master/console/#/realms/${ssoConfig.realm}/users/${id}`}
    >
      {id}
    </a>
  );
};

export default UserIdLink;
